"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = require("mobx");
var _1 = require(".");
var mobx_utils_1 = require("mobx-utils");
var map = require('lodash/map');
var filter = require('lodash/filter');
var find = require('lodash/find');
var some = require('lodash/some');
var every = require('lodash/every');
var reduce = require('lodash/reduce');
var chunk = require('lodash/chunk');
var forEach = require('lodash/forEach');
var orderBy = require('lodash/orderBy');
/**
 * Default collection options.
 */
exports.defaults = {
    create: function (input, opts) { return input; },
    getDataId: function (input, opts) { return input[opts.idAttribute || 'id']; },
    getModelId: function (existing, opts) { return existing[opts.idAttribute || 'id']; },
    idAttribute: 'id',
    update: function (existing, input, opts) { return Object.assign(existing, input); }
};
/**
 * Creates a collection.
 *
 * @type {T} The item type.
 * @type {O} Additional options.
 */
function collection(opts) {
    opts = Object.assign({}, exports.defaults, opts);
    // Holds the actual items.
    var items = mobx_1.observable.array([], { deep: false });
    var idMap = new Map();
    var self = {
        items: items,
        add: mobx_1.action(add),
        get: get,
        set: mobx_1.action(set),
        create: mobx_1.action(create),
        remove: mobx_1.action(remove),
        clear: mobx_1.action(clear),
        filter: bindLodashFunc(items, filter),
        some: bindLodashFunc(items, some),
        every: bindLodashFunc(items, every),
        find: bindLodashFunc(items, find),
        orderBy: bindLodashFunc(items, orderBy),
        map: bindLodashFunc(items, map),
        reduce: bindLodashFunc(items, reduce),
        chunk: bindLodashFunc(items, chunk),
        referenceOne: (function (ids, field) {
            return _1.referenceOne(self, ids, field);
        }),
        referenceMany: (function (ids, field) {
            return _1.referenceMany(self, ids, field);
        }),
        forEach: function (iteratee) {
            forEach(items, iteratee);
            return self;
        },
        at: function (index) { return items[index]; },
        slice: slice,
        move: move,
        get length() {
            return items.length;
        }
    };
    function get(id) {
        /*tslint:disable-next-line*/
        if (id === undefined || id === null) {
            return undefined;
        }
        if (Array.isArray(id)) {
            return id.map(get);
        }
        var idAsString = id.toString();
        var fromMap = idMap.get(idAsString);
        if (fromMap) {
            return fromMap;
        }
        var found = items.find(function (item) {
            var modelId = opts.getModelId(item, opts);
            if (!modelId) {
                return false;
            }
            return modelId.toString() === idAsString;
        });
        if (found !== undefined) {
            idMap.set(idAsString, found);
        }
        return found;
    }
    function set(data, setOpts) {
        setOpts = Object.assign({}, opts, setOpts);
        if (!data) {
            return undefined;
        }
        if (Array.isArray(data)) {
            return data.map(function (d) { return set(d, setOpts); });
        }
        var dataId = opts.getDataId(data, setOpts);
        if (dataId === undefined) {
            return undefined;
        }
        if (dataId === null) {
            throw new TypeError(dataId + " is not a valid ID");
        }
        dataId = dataId.toString();
        var existing = get(dataId);
        if (existing) {
            opts.update(existing, data, Object.assign({}, opts, setOpts));
            return existing;
        }
        var created = opts.create(data, Object.assign({}, opts, setOpts));
        // If creating this object resulted in another object with the same ID being
        // added, reuse it instead of adding this new one.
        existing = get(dataId);
        if (existing) {
            opts.update(existing, data, Object.assign({}, opts, setOpts));
            return existing;
        }
        items.push(created);
        idMap.set(dataId, created);
        return created;
    }
    function create(data, createOpts) {
        if (Array.isArray(data)) {
            return data.map(function (d) { return create(d, createOpts); });
        }
        createOpts = Object.assign({}, opts, createOpts);
        var dataId = createOpts.getDataId(data, createOpts);
        if (dataId !== undefined && dataId !== null) {
            return set(data, createOpts);
        }
        var created = createOpts.create(data, createOpts);
        add(created);
        return created;
    }
    function add(models) {
        if (!Array.isArray(models)) {
            return add([models]);
        }
        // Filter out existing models.
        models = models.filter(function (x) { return items.indexOf(x) === -1; });
        items.push.apply(items, models);
        return self;
    }
    function remove(modelOrId) {
        var model = typeof modelOrId === 'string' ||
            typeof modelOrId === 'number' ||
            modelOrId instanceof Date
            ? get(modelOrId)
            : modelOrId;
        if (!model) {
            return self;
        }
        items.remove(model);
        var modelId = opts.getModelId(model, opts);
        /* istanbul ignore else */
        if (modelId !== null && modelId !== undefined) {
            idMap.delete(modelId.toString());
        }
        return self;
    }
    function clear() {
        items.clear();
        idMap.clear();
        return self;
    }
    function slice(start, end) {
        return items.slice(start, end);
    }
    function move(fromIndex, toIndex) {
        mobx_utils_1.moveItem(items, fromIndex, toIndex);
        return self;
    }
    return self;
}
exports.collection = collection;
/**
 * Utility for binding lodash functions.
 */
function bindLodashFunc(items, func) {
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return func.apply(void 0, [items].concat(args));
    };
}
//# sourceMappingURL=collection.js.map